export const LOGIN = {
    REQUEST: 'AUTH.LOGIN.REQUEST',
    SUCCESS: 'AUTH.LOGIN.SUCCESS',
    FAILED: 'AUTH.LOGIN.FAILED',
};
